import { Trash2 } from "lucide-react";
import { Switch } from "../ui/switch";
import { UploadButton, useUploader } from "./ImageControls";
import { BackgroundRemover } from "./PhotoTools";
import { FlagPicker, flagTitle } from "./FlagPicker";
import { useFileData } from "../../lib/images";

const Row = ({ title, checked, onToggle, testId, children }) => (
  <div className="space-y-3">
    <div className="flex items-center justify-between">
      <span className="text-sm font-bold">{title}</span>
      <label className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-slate-500">
        {checked ? "Shown" : "Hidden"} <Switch checked={checked} onCheckedChange={onToggle} data-testid={testId} />
      </label>
    </div>
    {children}
  </div>
);

export const CrestFlagPanel = ({ sport, crest, flag, onCrest, onFlag }) => {
  const src = useFileData(crest.file);
  const { busy, upload } = useUploader((file) => onCrest({ ...crest, file, original: null, show: true }));
  return (
    <div className="space-y-6">
      <Row title="Club crest" checked={crest.show} onToggle={(show) => onCrest({ ...crest, show })} testId="crest-show-switch">
        <div className="flex flex-wrap items-center gap-2">
          {crest.file && src && <img src={src} alt="Club crest" className="h-14 w-14 border-2 border-slate-900 object-contain p-1" data-testid="crest-thumb" />}
          <UploadButton label={crest.file ? "Replace crest" : "Upload crest"} testId="crest-upload-button" onFile={upload} busy={busy} primary={!crest.file} />
          {crest.file && (
            <button type="button" onClick={() => onCrest({ ...crest, file: null, original: null })} data-testid="crest-remove-button"
              className="flex items-center gap-1.5 px-2 py-2 text-xs font-bold uppercase text-slate-500 hover:text-red-600"><Trash2 className="h-3.5 w-3.5" /> Remove</button>
          )}
        </div>
        {crest.file && <BackgroundRemover photo={crest} onChange={onCrest} prefix="crest" done="Crest background removed" restoreLabel="Restore original crest" />}
        <p className="text-xs text-slate-500">Crest has a white or coloured box behind it? Tap Remove background.</p>
      </Row>
      <Row title={flagTitle(sport, flag)} checked={flag.show} onToggle={(show) => onFlag({ ...flag, show })} testId="flag-show-switch">
        <FlagPicker sport={sport} flag={flag} onFlag={onFlag} />
      </Row>
    </div>
  );
};
